import { jsxs as l, jsx as o } from "react/jsx-runtime";
import m from "classnames";
import s from "../../utils/colors.js";
import { f } from "../../styled-qu50FBLM.mjs";
import { Svg as h, Title as a, Path as n } from "./Elements.js";
const z = ({
  className: r = "",
  viewBox: e = "0 0 22 19",
  fill: i = s.blueGrey,
  focusable: t
}) => /* @__PURE__ */ l(
  h,
  {
    className: m({ [r]: !!r }),
    viewBox: e,
    $cssHelper: f,
    role: "img",
    focusable: !!t,
    "aria-hidden": !t,
    children: [
      /* @__PURE__ */ o(a, { text: "Alert Error" }),
      /* @__PURE__ */ o(
        n,
        {
          fill: i,
          d: "M0 19h22L11 0zm12-3h-2v-2h2zm0-4h-2V8h2z",
          $transition: "fill 0.1s ease-in-out"
        }
      )
    ]
  }
);
export {
  z as default
};
